const router = [
  {
    path: "/kelola/instansi/:instansi_id/jenis-kelas",
    name: "jenis-kelas",
    meta: {
      auth: true,
      module: "Jenis Kelas"
    },
    component: () => import("./pages/List.vue")
  },
  {
    path: "/kelola/instansi:instansi_id/jenis-kelas/:jenis_kelas_id",
    name: "jenis-kelas.detail",
    meta: {
      module: "Detail Jenis Kelas",
      auth: true
    },
    component: () => import("./pages/Detail.vue")
  }
];

export default router;
